export const IMAGE_UPLOAD_HINT_TEXT =
  "Allowed: .jpg, .jpeg, .png, .webp • Recommended max size: 2MB";

export const RECOMMENDED_IMAGE_MAX_BYTES = 2 * 1024 * 1024;

export const IMAGE_UPLOAD_ERROR_INVALID_TYPE =
  "Invalid file type. Allowed: .jpg, .jpeg, .png, .webp";

export const IMAGE_UPLOAD_ERROR_MAX_SIZE =
  "File exceeds 2MB. Please choose a smaller image.";
